export const environment = {
  production: false,
  apiUrl: 'https://as-aeu-sds-dev-trasdata.azurewebsites.net/api',
  appName: 'Trasdata Front',
  version: '1.0.0',
};
